import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';

function fireAction(eventData) {
  EventToolbox.fireTrackAction({
    ads: {
      disable_refresh: true,
    },
    ...eventData,
  });
}

export function fireHomeHeroThumbnailSelect(trackingData) {
  const eventData = {
    action_category: 'user',
    action_cause: 'click',
    action_name: TrackingConstant.ACTION_VIEW_CONTENT,
    subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
    carousel_index: trackingData.currentIndex,
    carousel_prev_index: trackingData.prevIndex,
    carousel_total: trackingData.totalSlides,
    value: trackingData.value,
    creative_id: trackingData.creativeId,
  };

  fireAction({ event_type: 'action_completed', event_data: eventData });
}

export function fireHighImpactTabSelect(trackingData) {
  const eventData = {
    action_category: 'user',
    action_name: TrackingConstant.ACTION_VIEW_CONTENT,
    subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
    action_cause: trackingData.actionCause,
    carousel_index: trackingData.carouselIndex,
    carousel_prev_index: trackingData.carouselPrevIndex,
    carousel_total: trackingData.carouselTotal,
    value: trackingData.trackingValue,
    creative_id: trackingData.creativeId,
  };

  fireAction({ event_type: 'action_completed', event_data: eventData });
}

export function fireVehicleShowcaseThumbnailSelect(trackingData) {
  const eventData = {
    action_category: 'user',
    action_name: TrackingConstant.ACTION_VIEW_CONTENT,
    subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
    action_cause: trackingData.actionCause,
    carousel_index: trackingData.carouselIndex,
    carousel_prev_index: trackingData.carouselPrevIndex,
    value: trackingData.trackingValue,
    creative_id: trackingData.creativeId,
  };

  fireAction({ event_type: 'action_completed', event_data: eventData });
}

export function fireBuyingGuideSegmentSelect(trackingData) {
  const eventData = {
    action_category: 'user',
    action_name: TrackingConstant.ACTION_VIEW_CONTENT,
    subaction_name: TrackingConstant.ACTION_VIEW_CONTENT,
    action_cause: TrackingConstant.ACTION_CAUSE_CLICK,
    carousel_index: trackingData.index,
    value: trackingData.trackingValue,
    creative_id: trackingData.creativeId,
  };

  fireAction({ event_type: 'action_completed', event_data: eventData });
}
